<template>
    <section class="content">
        <div class="table-responsive">
            <table class="table table-hover" ref="tableuser">
                <thead>
                    <tr>
                        <th>NAMA LEMBAGA</th>
                        <th>SINGKATAN</th>
                        <th>ALAMAT</th>
                        <th>WEBSITE</th>
                        <th>CONTACT PERSON</th>
                        <th>JABATAN</th>
                        <th>INFO</th>
                        <th>NO. TELP</th>
                        <th>TINDAKAN</th>
                    </tr>
                </thead>
                <tbody @click="handleClick">
                </tbody>
            </table>
        </div>
        <div class="modal" tabindex="-1" role="dialog" ref="formDialog" data-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <form role="form" @submit="submitForm">
                        <div class="modal-header">
                            <h4 class="modal-title">{{ formTitle }}</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body row">
                            <p v-if="errors.length" class="alert alert-danger">
                                <b>Please correct the following error(s):</b>
                                <ul>
                                    <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                                </ul>
                            </p>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Nama Lembaga</label>
                                <input type="hidden" name="row_id" value="" v-model="form.id"/>
                                <input id="name" class="form-control name" v-model="form.name" type="text" required="required" name="name" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Singkatan</label>
                                <input id="singkatan" class="form-control" v-model="form.singkatan" type="text" required="required" name="singkatan" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Alamat</label>
                                <textarea class="form-control" v-model="form.address"></textarea>
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Website</label>
                                <input id="website" class="form-control website" v-model="form.website" type="text" required="required" name="website" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Phone</label>
                                <input id="phone" class="form-control phone" v-model="form.phone" type="number" required="required" name="phone" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Email</label>
                                <input id="email" class="form-control email" v-model="form.email" type="email" required="required" name="email" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">Contact Person</label>
                                <input id="cp_name" class="form-control cp_name" v-model="form.cp_name" type="text" required="required" name="cp_name" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">CP Jabatan</label>
                                <input id="cp_role" class="form-control cp_role" v-model="form.cp_role" type="text" required="required" name="cp_role" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">CP Phone</label>
                                <input id="cp_phone" class="form-control cp_phone" v-model="form.cp_phone" type="text" required="required" name="cp_phone" />
                            </div>
                            <div class="col-md-6 form-group">
                                <label class="control-label">CP Email</label>
                                <input id="cp_email" class="form-control cp_email" v-model="form.cp_email" type="text" required="required" name="cp_email" />
                            </div>
                            <div class="col-md-12 form-group">
                            <label class="control-label">Info Ujian</label>
                            <textarea
                                class="form-control"
                                id="info"
                                rows="3"
                                v-model="form.info"
                                placeholder="Tuliskan info ujian"></textarea>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Save changes</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
    <!-- /.content -->
</template>
<script>
import { createTable, authFetch } from '@/libs/hxcore';
import $ from 'jquery';
import vSelect from 'vue-select';
import Swal from "sweetalert2";
import "vue-select/dist/vue-select.css";
export default {
    name: 'DataSekolahDinas',
    components: {
        vSelect,
    },
    data() {
        return {
            errors: [],
            method: '',
            roles: '',
            formTitle: 'Tambah',
            form: {
                name: '',
                singkatan: '',
                address: '',
                website: '',
                phone: '',
                email: '',
                cp_name: '',
                cp_role: '',
                cp_phone: '',
                cp_email: '',
                info: '',
            },
        }
    },
    created: function() {
        this.roles = this.$route.meta.roles;
        console.log('load initial data', this.$route)
    },
    methods: {
        handleClick(e) {
            if (e.target.matches('.link-role')) {
                this.$router.push({ path: '/permit/' + e.target.dataset.id })
                return false;
            }

            if (e.target.closest("button")) {
                if (e.target.dataset.action == "view") {
                    this.$router.push("/dinas-tahapan-tes/" + e.target.dataset.id);
                }
            }
        },
        submitForm: function(ev) {
            const e = this.$refs;
            
            var data = Object.keys(this.form).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.form[key])).join('&')
            var urlSubmit = '/management/sekolah_dinas';
            if (this.method == 'PUT') urlSubmit = '/management/sekolah_dinas/' + this.form.id;

            authFetch(urlSubmit, {
                    method: this.method,
                    body: data
                })
                .then(res => {
                    if (res.status === 201) {

                    } else if (res.status === 400) {}
                    return res.json();
                })
                .then(js => {

                    this.errors = [];
                    if (!js.success) {
                        console.log(js.details)

                        for (var key in js.details) {
                            if (js.details.hasOwnProperty(key)) {
                                this.errors.push(js.details[key])
                            }
                        }

                        return;
                    }
                    this.table.api().ajax.reload();
                    $(e.formDialog).modal('hide');
                });

            ev.preventDefault();
        }
    },
    mounted() {
        const e = this.$refs;
        var self = this;
        this.table = createTable(e.tableuser, {
            "title": "",
            "roles": this.$route.params.roles,
            "ajax": "/management/sekolah_dinas",
            "columns": [
                { "data": "name" },
                { "data": "singkatan" },
                { "data": "address", "width": "150px" },
                { "data": "website" },
                { "data": "cp_name" },
                { "data": "cp_role" },
                { "data": "info", "width": "150px" },
                { "data": "phone" },
                { "data": "act",
                "sortable": false,
                "render": function (data, type, row, meta) {
                    return `<div class="btn-group"><button type="button" class="btn btn-sm btn-outline-info" data-action="view" data-id="`+row.id+`"><i class="fas fa-eye"></i> Detail Tahapan Tes</button></div>`;
                } },
            ],
            filterBy: [0, 1, 2, 3, 4, 5, 7],
            scrollX: true,
            rowCallback: function(row, data) {},
            buttonClick: (evt) => {
                if (evt.role == 'create') {
                    self.form = {};
                    self.method = 'POST';
                    self.errors = [];
                    self.formTitle = 'Tambah Data';
                    $(e.formDialog).modal('show');
                } else if (evt.role == 'update' && evt.data) {
                    self.form = evt.data;
                    self.method = 'PUT';
                    self.errors = [];
                    self.formTitle = 'Edit Data';
                    $(e.formDialog).modal('show');
                } else if (evt.role == 'delete' && evt.data) {
                    self.form = evt.data;
                    Swal.fire({
                        title: "Hapus data?",
                        icon: "question",
                        denyButtonText: '<i class="fa fa-times"></i> Hapus',
                        showCancelButton: true,
                        showDenyButton: true,
                        showConfirmButton: false,
                    }).then((result) => {
                        if (result.isDenied) {
                        authFetch("/management/sekolah_dinas/" + evt.data.id, {
                            method: "DELETE",
                            body: "id=" + evt.data.id,
                        })
                            .then((res) => {
                            return res.json();
                            })
                            .then((js) => {
                            this.table.api().ajax.reload();
                            });
                        }
                    });
                }

            },
        });

    }
}
</script>